import { message } from "antd";
import { useState } from "react";
import { updateProject } from "V2.0/services/projectService";
import { showErrorToast } from "V2.0/utils";
import InputComponent from "V2.0/components/InputComponent";
import { Button } from "V2.0/common/button";
import { ErrorMessage } from "V2.0/common/fieldset";

function WorkspaceTagCreate(props) {
  const { workspaceId, workspaceTags, onCreateNewTags } = props;
  const [createdTag, setCreatedTag] = useState("");
  const [error, setError] = useState({
    isError: false,
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const updateWorkspaceTags = async () => {
    const sanitizedTag = createdTag
      .trim()
      .split(" ")
      .map((word) => word.toLowerCase())
      .join("-");

    if (workspaceTags.includes(sanitizedTag)) {
      setError({
        isError: true,
        message: "Tag already exist",
      });
      return;
    }

    const nextWorkspaceTags = [...workspaceTags, sanitizedTag];
    setLoading(true);
    const payload = {
      workspaceTags: nextWorkspaceTags,
    };
    try {
      const response = await updateProject(workspaceId, payload);
      if (response.status === 200) {
        setLoading(false);
        message.destroy();
        message.success("Tag added");
        onCreateNewTags(createdTag);
        setCreatedTag("");
      }
    } catch (e) {
      setLoading(false);
      showErrorToast(e, "Failed to update tags");
    }
  };

  const isAddDisabled = !Boolean(createdTag) || error.isError;

  return (
    <div className="mb-2">
      <div className="w-full flex items-center gap-x-4">
        <div className="w-full">
          <InputComponent
            label=""
            value={createdTag}
            placeholder="Enter tag name"
            type="text"
            onChange={(e) => {
              e.stopPropagation();
              setError({
                isError: false,
                message: "",
              });
              setCreatedTag(e.target.value);
            }}
            invalid={error.isError}
          />
        </div>
        <div className="flex-none">
          <Button
            onClick={updateWorkspaceTags}
            disabled={isAddDisabled}
            loading={loading}
          >
            Create
          </Button>
        </div>
      </div>
      {error.isError && <ErrorMessage>{error.message}</ErrorMessage>}
    </div>
  );
}

export default WorkspaceTagCreate;
